import React from 'react';
import { ComingSoonPage } from '../components/ComingSoonPage';
export function HomePage() {
  return <ComingSoonPage data-id="element-807" />;
}